import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'

const Switch = React.forwardRef(({ className = '', ...props }, ref) => (
  <SwitchPrimitives.Root
    ref={ref}
    className={['ds-switch', className].filter(Boolean).join(' ')}
    style={{
      display: 'inline-flex',
      height: '1.5rem',
      width: '2.75rem',
      flexShrink: 0,
      cursor: 'pointer',
      alignItems: 'center',
      borderRadius: '9999px',
      border: '2px solid transparent',
      transition: 'background-color 0.2s',
      outline: 'none',
    }}
    {...props}
  >
    <SwitchPrimitives.Thumb
      style={{
        pointerEvents: 'none',
        display: 'block',
        height: '1.25rem',
        width: '1.25rem',
        borderRadius: '50%',
        background: '#ffffff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        transition: 'transform 0.2s',
      }}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
